var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-10 -6 38 38"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6 20v-8.5h2.9l.4-3.3h-3.3V6.1c0-1 .3-1.6 1.6-1.6H14v-3c-.3 0-1.3-.1-2.6-.1-2.5 0-4.3 1.5-4.3 4.4v2.4H4.3v3.3h2.9V20h3.4z",
    fill: "#fff"
  })));
}
export default SvgFacebook;